import React, { useState } from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { WifiTetheringOff, MarkEmailUnread, Send } from '@mui/icons-material/';

const style = { //Estilos para el contenedor del mensaje.
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1100,
    bgcolor: '#161B22',
    border: '2px solid #161B22',
    color: '#ffffff',
    boxShadow: 24,
    p: 5,
    display: "flex",
    zIndex: 300000
};

const textBoldStyle = { //Estilo para los textos en negritas
    fontWeight: 'bold',
    width: "100%",
    marginRight: "5px"
}

// ModalSendMessageMass: Componente que renderiza la confirmación para enviar mensajes masivos.

const ModalSendMessageMass = ({ openModal, setOpenModal }) => {
    const handleClose = () => setOpenModal(false);
    const [open, setOpen] = useState(true);
    return (
        <Modal open={openModal} onClose={handleClose} aria-labelledby="modal-modal-title" sx={{ zIndex: 100000 }}
            aria-describedby="modal-modal-description">
            <Box sx={style}>
            <div className="container-title-with-description" >
                    <Typography id="modal-modal-description" variant="h5" sx={{ width: "100%" }}
                        fontFamily="Poppins" fontWeight="600">
                        Confirmar Envío de Mensajes
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 3 }} fontFamily="Poppins" >
                        Desea enviar 1 mensaje por el método de envíos masivos
                    </Typography>
                </div>

                <div>
                    <div className="container-instruccion-with-data" >
                        <div className="container-intruccion-with-data__data">
                            <span><MarkEmailUnread sx={{ marginRight: "20px", fontSize: "30px" }} /></span>
                            <div className="container-browser-with-data" >

                                <div className="hour-with-ip">
                                    <Typography id="modal-modal-description" fontFamily="Poppins"
                                        justifyContent="center" display="flex" sx={{ flexDirection: "column" }}>
                                        Sr. @Nombre le recordamos que su boleta nro @Boleta podría pasar
                                        a remate. Mas info https://bit.ly/WhatsApp-LAPLATA
                                    </Typography>
                                </div>
                            </div>
                        </div>
                        <div className="container-intruccion-with-data__data">
                            <span><MarkEmailUnread sx={{ marginRight: "20px", fontSize: "30px" }} /></span>
                            <div className="container-browser-with-data" >

                                <div className="hour-with-ip">
                                    <Typography id="modal-modal-description" fontFamily="Poppins"
                                        justifyContent="center" display="flex" sx={{ flexDirection: "column" }}>
                                        Sr. @Nombre le recordamos que sus boletas podrían pasar a remate.
                                        Mas info https://bit.ly/WhatsApp-LAPLATA
                                    </Typography>
                                </div>
                            </div>
                        </div>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} fontFamily="Poppins" justifyContent="center" display="flex">
                            <button className="btn-submit-info" style={{ display: "flex", alignItems: "center" }}
                                onClick={() => setOpenModal(false)}>
                                <Send sx={{ marginRight: "10px" }} />
                                Confirmar Envío
                            </button>
                        </Typography>
                    </div>
                </div>

            </Box>
        </Modal>
    )
};

export default ModalSendMessageMass;